export const ACTION_PAGE = 'ACTION_PAGE'
export const ACTION_LOGIN = 'ACTION_LOGIN'
export const ACTION_TEAM_VISUAL_IDENTITY = 'ACTION_TEAM_VISUAL_IDENTITY'
export const ACTION_TEAM_CONFIG = 'ACTION_TEAM_CONFIG'
export const ACTION_USER_PERMISSIONS = 'ACTION_USER_PERMISSIONS'
export const ACTION_USER_PROFILE = 'ACTION_USER_PROFILE'
export const ACTION_REPLY = 'ACTION_REPLY'
export const ACTION_SET_AUTHENTICATION = 'ACTION_SET_AUTHENTICATION'

// Channel / Canais
export const ACTION_CHANNELS_SET = 'ACTION_CHANNELS_SET'
export const ACTION_CHANNELS_UPDATE = 'ACTION_CHANNELS_UPDATE'
export const ACTION_CHANNELS_ADD = 'ACTION_CHANNELS_ADD'
export const ACTION_CHANNELS_REMOVE = 'ACTION_CHANNELS_REMOVE'
export const ACTION_CHANNELS_CONNECTION_STATE = 'ACTION_CHANNELS_CONNECTION_STATE'
export const ACTION_CHANNELS_CURRENT = 'ACTION_CHANNELS_CURRENT'

